import { Injectable } from '@angular/core';
import { MainFilterRaw } from '@core/models/main-filter-view';
import { ChromeExtensionService } from './chrome-extension/chrome-extension.service';
import { Router } from '@angular/router';
import { TabData, getTabs } from '@core/static/tabs';
import { Company } from '@core/models/company';
import { AuthService } from '@core/auth/auth.service';
import { UserRole } from '@core/models/user';
import { InvestorTab, ModalActions, Tab } from '@core/models/types';
import { Nullable } from '@core/models/nullable';
import { CompanyHelperService } from '@core/services/company-helper.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, delay, } from 'rxjs';
import { FilterHelperService } from '@core/services/filter-helper.service';

@Injectable({
  providedIn: 'root'
})
export class TabUtilsService {

  refreshData = new BehaviorSubject<void>(void 0);
  public clearFilters = new BehaviorSubject<void>(void 0);
  tabs!: Record<UserRole, TabData<Company>[]>;
  currentTabIndex: Tab;
  currentChildIndex: Nullable<number> = null;
  companyDetailsDismissible = true;
  totalCount!: number;
  currentTotal!: number;

  get isExtension(): boolean {
    return this.chromeExtensionService.isExtension.getValue();
  }

  constructor(public chromeExtensionService: ChromeExtensionService,
    public router: Router,
    public authService: AuthService,
    public companyHelperService: CompanyHelperService,
    public filterHelper: FilterHelperService,) {
    this.loadTabsData();
    this.currentTabIndex = InvestorTab.COMPANIES;
    this.trackCompanyDetailsDismissibleState();
  }

  trackCompanyDetailsDismissibleState() {
    this.companyHelperService.companyDetailsDismissible
      .pipe(delay(10))
      .subscribe((dismissible) => (this.companyDetailsDismissible = dismissible));
  }


  getAvailableUserTabs(tabs: Record<UserRole, TabData<Company>[]>): TabData<Company>[] {
    return tabs[this.authService.userRole];
  }


  loadTabsData() {
      this.tabs = {
        admin: getTabs("admin", this.authService.userRoles),
        investor: getTabs("investor", this.authService.userRoles),
        analyst: getTabs("analyst", this.authService.userRoles),
        votercommittee: getTabs("votercommittee", this.authService.userRoles),
        investmentcommitteeadmin: getTabs("investmentcommitteeadmin", this.authService.userRoles),
        investorrelation: getTabs("investorrelation", this.authService.userRoles),
        newslettermoderator: getTabs("newslettermoderator", this.authService.userRoles),

      };
  }
  navigateToCompany(company: Company, replaceUrl = false, fragment: Nullable<string> = null) {
    if (fragment) {
      this.router.navigate(this.companyHelperService.generateCompanyDetailsUrl(company), {
        fragment,
        replaceUrl,
      });
    } else {
      this.router.navigate(this.companyHelperService.generateCompanyDetailsUrl(company), { replaceUrl });
    }
    document.title = company.name;
  }
}